"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportConfiguration = void 0;
const shared_1 = require("../../../../backend/features/configurable-lists/shared");
const shared_2 = require("../../../../backend/features/editable-pages/shared");
const shared_3 = require("../../../../backend/features/editable-settings/shared");
function exportConfiguration({ t, features, classifiers, progressCallback, getFunctionClient, getStorageClient, }) {
    let status = 'counting';
    let total = 0;
    let count = 0;
    const cancelRef = { cancel: false };
    const result = {};
    progressCallback({ status, total, count });
    (function () {
        return __awaiter(this, void 0, void 0, function* () {
            if (features.includes('editable-settings')) {
                total += (yield getFunctionClient().executeFunction({
                    functionName: 'getSettingsByGroup',
                    params: { filter: [{ column: 'readOnly', op: '=', value: false }], limit: 0 },
                })).result.total;
                if (cancelRef.cancel) {
                    return;
                }
            }
            if (features.includes('editable-pages')) {
                total += yield getStorageClient(shared_2.editablePageEntityName).count({});
                if (cancelRef.cancel) {
                    return;
                }
            }
            if (features.includes('configurable-lists')) {
                total += yield getStorageClient(shared_1.configurableListEntityName).count({});
                if (cancelRef.cancel) {
                    return;
                }
            }
            if (features.includes('classifiers') && classifiers) {
                for (const { entityName } of classifiers) {
                    total += yield getStorageClient(entityName).count({});
                    if (cancelRef.cancel) {
                        return;
                    }
                }
            }
            status = 'exporting';
            let label = '';
            progressCallback({ status, total, count });
            if (features.includes('editable-settings')) {
                label = t('configurationTransfer.featuresEnum.editable-settings');
                progressCallback({ status, total, count, label });
                result['editable-settings'] = (yield getAllData({
                    settingFunctionClient: getFunctionClient(),
                    storageClient: getStorageClient(shared_3.settingEntityName),
                    cancelRef,
                    countCallback: () => {
                        progressCallback({ status, total, count: ++count, label });
                    },
                })).map(({ name, value }) => ({ name, value }));
                if (cancelRef.cancel) {
                    return;
                }
                label = '';
            }
            if (features.includes('editable-pages')) {
                label = t('configurationTransfer.featuresEnum.editable-pages');
                progressCallback({ status, total, count, label });
                result['editable-pages'] = yield getAllData({
                    storageClient: getStorageClient(shared_2.editablePageEntityName),
                    cancelRef,
                    countCallback: () => {
                        progressCallback({ status, total, count: ++count, label });
                    },
                });
                if (cancelRef.cancel) {
                    return;
                }
                label = '';
            }
            if (features.includes('configurable-lists')) {
                label = t('configurationTransfer.featuresEnum.configurable-lists');
                progressCallback({ status, total, count, label });
                result['configurable-lists'] = yield getAllData({
                    storageClient: getStorageClient(shared_1.configurableListEntityName),
                    cancelRef,
                    countCallback: () => {
                        progressCallback({ status, total, count: ++count, label });
                    },
                });
                if (cancelRef.cancel) {
                    return;
                }
                label = '';
            }
            if (features.includes('classifiers') && classifiers) {
                const classifiersResult = {};
                for (const { entityName, label: classifierLabel, onExportMapData } of classifiers) {
                    label = t('configurationTransfer.classifier') + ' ' + classifierLabel;
                    progressCallback({ status, total, count, label });
                    classifiersResult[entityName] = yield getAllData({
                        storageClient: getStorageClient(entityName),
                        cancelRef,
                        countCallback: () => {
                            progressCallback({ status, total, count: ++count, label });
                        },
                        onExportMapData: onExportMapData,
                    });
                    if (cancelRef.cancel) {
                        return;
                    }
                    label = '';
                }
                result['classifiers'] = classifiersResult;
            }
        });
    })()
        .then(() => {
        status = cancelRef.cancel ? 'canceled' : 'done';
        progressCallback({ status, total, count, result: status === 'done' ? JSON.stringify(result) : undefined });
    })
        .catch((error) => {
        status = 'error';
        progressCallback({ status, total, count, error });
    });
    return {
        cancel: () => {
            status = 'canceling';
            progressCallback({ status, total, count });
            cancelRef.cancel = true;
        },
    };
}
exports.exportConfiguration = exportConfiguration;
function getAllData(_a) {
    return __awaiter(this, arguments, void 0, function* ({ settingFunctionClient, storageClient, cancelRef, countCallback, onExportMapData, }) {
        const ids = settingFunctionClient
            ? (yield settingFunctionClient.executeFunction({
                functionName: 'getSettingsByGroup',
                params: { filter: [{ column: 'readOnly', op: '=', value: false }] },
            })).result.rows.map((row) => row.id)
            : (yield storageClient.list({})).rows.map((row) => row.id);
        const result = [];
        if (cancelRef.cancel) {
            return result;
        }
        for (const id of ids) {
            const response = yield storageClient.get(id);
            let data = response.data;
            if (onExportMapData) {
                if (cancelRef.cancel) {
                    return result;
                }
                data = yield onExportMapData(response);
            }
            result.push(data);
            countCallback();
            if (cancelRef.cancel) {
                return result;
            }
        }
        return result;
    });
}
